import { createClient } from 'contentful';

// Initialize Contentful client
const client = createClient({
  space: process.env.REACT_APP_CONTENTFUL_SPACE_ID,
  accessToken: process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN,
  environment: process.env.REACT_APP_CONTENTFUL_ENVIRONMENT || 'master',
});

// Fetch all blog posts
export const getBlogPosts = async () => {
  try {
    const response = await client.getEntries({
      content_type: 'pageBlogPost',
      order: '-fields.publishedDate',
    });
    
    return response.items.map(item => ({
      id: item.sys.id,
      title: item.fields.title,
      slug: item.fields.slug,
      subtitle: item.fields.shortDescription,
      content: item.fields.content,
      publishedDate: item.fields.publishedDate,
      featuredImage: item.fields.featuredImage?.fields?.file?.url,
      author: item.fields.author?.fields,
    }));
  } catch (error) {
    console.error('Error fetching blog posts:', error);
    return [];
  }
};

// Fetch a single blog post by slug
export const getBlogPostBySlug = async (slug) => {
  try {
    const response = await client.getEntries({
      content_type: 'pageBlogPost',
      'fields.slug': slug,
      limit: 1,
    });

    if (response.items.length === 0) {
      return null;
    }

    const item = response.items[0];
    return {
      id: item.sys.id,
      title: item.fields.title,
      slug: item.fields.slug,
      subtitle: item.fields.shortDescription,
      content: item.fields.content,
      publishedDate: item.fields.publishedDate,
      featuredImage: item.fields.featuredImage?.fields?.file?.url,
      author: item.fields.author?.fields,
      relatedPosts: item.fields.relatedBlogPosts || [],
    };
  } catch (error) {
    console.error('Error fetching blog post:', error);
    return null;
  }
};